export enum OutgoingInvoiceTabsEnum {
  POSITIONS = 'positions',
  BILLING_INFORMATION = 'billing information',
  DOCUMENTS = 'documents',
  PREFERENCES = 'preferences'
}
